// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + {"329":"datepicker","926":"lightgallery"}[chunkId] + "." + chunkId + "." + {"329":"6e7dbb80557db229d10e","926":"ea92490daefe0373af62"}[chunkId] + ".css";
};